import { useApiQuery } from '../../../../hooks/useApi';
import { knowledgeService } from '../../../../services/knowledgeService';
import { useWorkspaceStore } from '../../../../stores/workspaceStore';

export function useExistingTags() {
  const workspaceId = useWorkspaceStore((s) => s.currentWorkspace?.id);

  const { data, isLoading } = useApiQuery<string[]>({
    queryKey: ['knowledge-tags', workspaceId],
    queryFn: () => {
      if (!workspaceId) return Promise.resolve([]);
      return knowledgeService.getTags(workspaceId);
    },
    enabled: !!workspaceId,
    showErrorToast: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    tags: data || [],
    isLoading,
  };
}